import { useState } from "react";

// Compact, collapsed-by-default FAQ list — shared between CbmCalculatorPage
// and BeyondCbmPage so both read consistently instead of each page inventing
// its own big always-expanded article-style Q&A block.
// items: [{ id, question, answer }] — answer may be a string or JSX.
export function FaqAccordion({ items }) {
  const [openIds, setOpenIds] = useState(() => new Set());

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <div className="divide-y divide-white/5 rounded-2xl border border-white/10 bg-white/[0.02]">
      {items.map(({ id, question, answer }) => {
        const isOpen = openIds.has(id);
        return (
          <div key={id} id={id} className="scroll-mt-28">
            <button
              type="button"
              onClick={() => toggle(id)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-white/[0.03]"
            >
              <span className="text-sm font-bold text-white md:text-base">{question}</span>
              <span
                className={`material-symbols-outlined shrink-0 text-slate-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
              >
                expand_more
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-4 text-sm leading-relaxed text-slate-300 md:text-[15px]">
                {answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
